var React = require('react');

function ArrowLineTop (props) {
    return React.createElement("symbol",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M6.127 2.06v9.324c0 .173-.059.32-.185.435a.592.592 0 0 1-.446.181.592.592 0 0 1-.446-.18.593.593 0 0 1-.186-.436V2.06l-2.77 2.7a.6.6 0 0 1-.437.181.654.654 0 0 1-.447-.18.567.567 0 0 1-.017-.87L4.966.213A.702.702 0 0 1 5.218.05a.839.839 0 0 1 .573 0 .737.737 0 0 1 .252.164l3.772 3.678c.126.123.185.27.185.435a.605.605 0 0 1-.202.443.723.723 0 0 1-.446.189.608.608 0 0 1-.446-.19l-2.77-2.7-.009-.008z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"transform":"rotate(-90 6 6)","d":"M0 0h12v12H0z"})))]);
}

ArrowLineTop.displayName = "ArrowLineTop";

ArrowLineTop.defaultProps = {"viewBox":"0 0 12 12"};

module.exports = ArrowLineTop;

ArrowLineTop.default = ArrowLineTop;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/arrow-line-top.svg
// module id = 1255
// module chunks = 0